import type * as lazyIndex from './lazyIndex';
import { LazyModule, createLazyComponent, LazyAction, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MonarchWin32Toggle" */ './lazyIndex'),
    { name: 'MonarchWin32Toggle' }
);

export const MonarchWin32Toggle: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.MonarchWin32Toggle
);

export const lazyIsToggleEnabled: LazyAction<typeof lazyIndex.isToggleEnabled, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.isToggleEnabled);

export const lazyUntoggleAndProvideFeedbackIfSupported: LazyAction<
    typeof lazyIndex.untoggleAndProvideFeedbackIfSupported,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.untoggleAndProvideFeedbackIfSupported);
